/* Bandera temporal para alternar a la vista Free NAS; despues dependera de la suscripcion del usuario */
export const FREE_NAS_VIEW = false;

export const FreeNasPonds = {
  icon: "",
  text: "free_nas.header.ponds",
  link: "/free-nas",
  img: "",
  available: true,
  permission: "view_farms"
};

/* Opciones del header de Free NAS; svg es la ruta del icono dentro de assets */
export const FreeNasHeaderMenu = [
  {
    text: "free_nas.header.ponds",
    link: "/free-nas",
    svg: "menu-icons/farm.svg"
  },
  /* Mismo nombre e icono que la opcion de ciclos del sidebar normal */
  {
    text: "sidebar.cycles-plantings",
    link: "/free-nas/ciclos-siembras",
    svg: "menu-icons/sows.svg"
  }
];
